export default "__VITE_ASSET__BLJnm0RG__"